<template>
  <div style="background-color: #f7f7f7">
    <div class="title_div">
      <div
        style="
          height: 6vh;
          line-height: 12vh;
          font-size: 4.6vw;
          display: flex;
          justify-content: center;
        "
      >
        <div v-if="user_type2">区域看板</div>
        <div v-else>{{ pagetype == 1 ? "总部看板" : "门店看板" }}</div>
      </div>
      <div
        style="
          display: flex;
          justify-content: flex-end;
          font-size: 3.5vw;
          margin-right: 3vw;
        "
      >
        <div>{{ new_show_date }}</div>
      </div>
    </div>
    <!--列表1 dashed-->
    <div style="display: flex; margin-top: 2vh; justify-content: center">
      <div
        style="
          display: flex;
          height: 12vh;
          align-items: center;
          background-color: #ffffff;
        "
      >
        <div
          v-for="(item, index) in table_data1"
          :key="index"
          class="every_option1"
          :style="
            index < 3 ? 'border-right: 1px solid rgba(204, 204, 204, 0.3);' : ''
          "
        >
          <img :src="item ? item.img : ''" style="height: 6vw; width: 6vw" />
          <div style="font-size: 3.6vw; margin-top: 0.6vh">
            {{ item ? item.name : "" }}
          </div>
          <div style="font-size: 3vw; margin-top: 0.6vh; color: #898989">
            {{ item ? item.value : "" }}
          </div>
        </div>
      </div>
    </div>

    <!--时间-->
    <div style="display: flex; justify-content: center; margin-top: 1.4vh">
      <div
        style="
          display: flex;
          height: 6vh;
          align-items: center;
          background-color: #ffffff;
        "
      >
        <div
          v-for="(item, index) in time_item"
          :key="index"
          class="every_time"
          @click="chooseTime(index)"
          :style="
            index < 3 ? 'border-right: 1px solid rgba(204, 204, 204, 0.3);' : ''
          "
        >
          <img
            v-if="time_value != index"
            :src="item.icon"
            style="height: 5.2vw; width: 5.2vw"
          />
          <img
            v-else
            :src="item.icon_xuan"
            style="height: 5.2vw; width: 5.2vw"
          />
          <div
            class="time_choose"
            :style="time_value == index ? 'color:#2163E5;' : ''"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <!--销售汇总区-->
    <div
      style="
        display: flex;
        margin-top: 1.6vh;
        align-items: center;
        margin-left: 5vw;
        margin-bottom: 1vh;
      "
    >
      <img src="@/assets/icon/xiaoshouhuizong.png" class="option_img" />
      <div class="option_title">销售汇总区</div>
    </div>
    <!--列表2-->
    <div style="display: flex; flex-wrap: wrap; margin-left: 4vw">
      <div
        v-for="(item, index) in table_data2"
        :key="index"
        class="every_option2"
        :style="(index + 1) % 3 != 0 ? 'margin-right:1vw;' : ''"
      >
        <!-- {{ index }} -->
        <!-- <div class="option2_font">同比:↑0.64 &nbsp;&nbsp; 环比:↑0.72</div> -->
        <div
          style="
            font-weight: 800;
            font-size: 3.6vw;
            margin-left: 1vw;
            margin-top: 1vh;
            text-align: center;
          "
        >
          {{ item ? item.name : "" }}
        </div>
        <div
          style="
            display: flex;
            display: flex;
            justify-content: space-between;
            margin-top: 0.4vh;
            margin: 1vh 0;
          "
        >
          <div class="option2_font2">{{ item ? item.value : "" }}</div>
          <img
            :src="item ? item.img : ''"
            style="height: 6.6vw; width: 6.6vw; margin-right: 2vw"
          />
        </div>
      </div>
    </div>
    <div style="display: flex; flex-wrap: wrap; margin-left: 4vw">
      <div
        v-for="(item, index) in table_data666"
        :key="index"
        class="every_option2"
        :style="(index + 1) % 3 != 0 ? 'margin-right:1vw;' : ''"
      >
        <!-- {{ index }} -->
        <!-- <div class="option2_font">同比:↑0.64 &nbsp;&nbsp; 环比:↑0.72</div> -->
        <div
          style="
            font-weight: 800;
            font-size: 3.6vw;
            margin-left: 1vw;
            margin-top: 1vh;
            text-align: center;
          "
        >
          {{ item ? item.name : "" }}
        </div>
        <div
          style="
            display: flex;
            display: flex;
            justify-content: space-between;
            margin-top: 0.4vh;
            margin: 1vh 0;
          "
        >
          <div class="option2_font2">{{ item ? item.value : "" }}</div>
          <img
            :src="item ? item.img : ''"
            style="height: 6.6vw; width: 6.6vw; margin-right: 2vw"
          />
        </div>
      </div>
    </div>
    <!--销售汇总区-->
    <div
      style="
        display: flex;
        margin: 1.6vh;
        align-items: center;
        margin-left: 5vw;
      "
    >
      <img src="@/assets/icon/xiaoshoue.png" class="option_img" />
      <div class="option_title">
        {{ pagetype == 2 ? "营业员" : "" }}销售额示意图
      </div>
    </div>
    <!--图表-->
    <div style="display: flex; justify-content: center">
      <!-- 总店图 -->
      <div
        v-if="pagetype == 1"
        class="line_body"
        :style="'width:' + (200 + line_data.length * 22) + 'px;'"
      >
        <LineChart id="zongbu" :table_data="line_data"></LineChart>
      </div>
      <!-- 门店图 -->
      <div
        v-if="pagetype == 2"
        class="line_body"
        :style="'width:' + (200 + line_data.length * 22) + 'px;'"
      >
        <LineChart id="mendian" :table_data="line_data"></LineChart>
      </div>
      <!-- 区域图(一天) -->
      <!-- <div v-if="pagetype==2&&user_type2&&(time_value==0||time_value==1)" class="line_body" style="width:360vw;">
        <LineChart id="360" :table_data="line_data"></LineChart>
      </div> -->
      <!-- 区域图(一周以上) -->
      <!-- <div v-if="pagetype==2&&user_type2&&(time_value==2||time_value==3)" class="line_body" style="width:360vw;">
        <LineChart id="360" :table_data="line_data"></LineChart>
      </div> -->
    </div>
    <!--门店排名-->
    <div style="display: flex; justify-content: center; margin-top: 2vh;">
      <div style="background-color: #ffffff; width: 92vw;">
        <div
          style="
            display: flex;
            align-items: center;
            margin-left: 2vw;
            height: 6vh;
          "
        >
          <img src="@/assets/icon/mendianpaiming.png" class="option_img" />
          <div class="option_title">
            {{ pagetype == 1 ? "门店排名" : "营业员销售排名" }}
          </div>
        </div>
        <div style="margin-left: 2vw; overflow: auto">
          <div
            style="
             width:125vw;
              display: flex;
              color: #9c9c9c;
              font-size: 3.2vw;
              margin-bottom: 0.5vh;
              overflow:scroll;
            "
          >
            <div style="min-width: 10vw; text-align: center">排名</div>
            <!-- <div v-for="(item,index) in table_data3[0]" :key="index" style="width:30vw;text-align:center;">{{index}}</div> -->
            <!-- <div style="width: 60vw; text-align: center">主体</div> -->
            <div v-if="pagetype == 1" style="width:40vw; text-align:center">
              主体
            </div>
            <div v-if="pagetype == 1" style="width:75vw; text-align:center">
              门店
            </div>
            
            <div v-if="pagetype == 2" style="width: 40vw; text-align: center">
              营业员
            </div>
            
            <div style="width: 50vw; text-align:center">销售额</div>
            <div style="width: 50vw; text-align:center">毛利额</div>
            <div style="width: 50vw; text-align: center">毛利率</div>
            <div style="width: 50vw; text-align:center">毛利3</div>
            <div style="width: 50vw; text-align: center">毛利率3</div>
            
            
            <div v-if="pagetype == 2" style="width: 40vw; text-align: center">
              会员销售额
            </div>
            <div v-if="pagetype == 2" style="width: 30vw; text-align: center">
              客单价
            </div>
            <div v-if="pagetype == 2" style="width: 30vw; text-align: center">
              客流量
            </div>
          </div>

          <div
            v-for="(item, index) in table_data3"
            :key="index"
            style="
            width:125vw;
              display: flex;
              color: #9c9c9c;
              font-size: 3vw;
              border-top: 1px solid #e2e2e2;
overflow:scroll;
            "
          >
            <div
              v-if="index < 3"
              style="
                min-width: 10vw;
                border-left: 1px solid #e2e2e2;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                v-if="index == 0"
                src="@/assets/icon/paiming1.png"
                class="ranking_icon"
              />
              <img
                v-if="index == 1"
                src="@/assets/icon/paiming2.png"
                class="ranking_icon"
              />
              <img
                v-if="index == 2"
                src="@/assets/icon/paiming3.png"
                class="ranking_icon"
              />
            </div>
            <div
              v-if="index > 2 && index < table_data3.length - 1"
              style="
                min-width: 10vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            >
              {{ index + 1 }}
            </div>
               <div
              v-if="pagetype == 1"
              style="
                width:40vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            >
              {{ item.主体 }}
            </div>
            <div
              v-if="index == table_data3.length - 1"
              style="
                min-width: 10vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            ></div>
            <!-- <div  v-for="(item2,index2) in item" :key="index2"  style="width:30vw;text-align:center;border-left:1px solid #E2E2E2;min-height:3vh;line-height:3vh;">{{item2}}</div> -->
            <el-tooltip :content="item.分支机构编码" placement="top">
              <div
              v-if="pagetype == 1"
              style="
             
                width: 75vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
                overflow: hidden; white-space: nowrap;
              "
            >
              {{ item.分支机构编码 }}
            </div>
</el-tooltip>
            <div
              v-if="pagetype == 2"
              style="
                width: 25vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            >
              {{ item.营业员 }}
            </div>
            <div
              style="
                width: 50vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            >
              {{ item.销售额 ? item.销售额 : "" }}
            </div>
            <div
              style="
                width: 50vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            >
              {{ item.毛利额? item.毛利额 : "" }}
            </div>
            <div
              style="
                width: 50vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            >
              {{ item.毛利率? item.毛利率 : "" }}
            </div>
            <div
              style="
                width: 50vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            >
              {{ item.gk毛利? item.gk毛利 : "" }}
            </div>
            <div
              style="
                width: 50vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            >
              {{ item.gk毛利率? item.gk毛利率 : "" }}
            </div>
          
            <div
              v-if="pagetype == 2"
              style="
                width: 40vw
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            >
              {{ item.会员销售额 }}
            </div>
            <div
              v-if="pagetype == 2"
              style="
                width: 30vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            >
              {{ item.客单价 }}
            </div>
            <div
              v-if="pagetype == 2"
              style="
                width: 30vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            >
              {{ item.客流量 }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--电商排名-->
    <div
      v-if="pagetype == 1"
      style="display: flex; justify-content: center; margin-top: 3vh"
    >
      <div style="background-color: #ffffff; width: 92vw" v-if="eight != 8">
        <div
          style="
            display: flex;
            align-items: center;
            margin-left: 2vw;
            height: 6vh;
          "
        >
          <img src="@/assets/icon/mendianpaiming.png" class="option_img" />
          <div class="option_title">电商排名</div>
        </div>
        <div style="margin-left: 2vw; overflow: scroll">
          <div
            style="
              display: flex;
              color: #9c9c9c;
              font-size: 3.2vw;
              margin-bottom: 0.5vh;
            "
          >
            <div style="min-width:8vw; text-align: left">排名</div>
            <div style="width: 35vw; text-align: left;">主体名称</div>
            <div style="width: 40vw; text-align: left">店铺名称</div>
            <div style="width: 30vw; text-align:left">销售额</div>
            <div style="width: 30vw; text-align: left">成本额</div>
            <div style="width: 30vw; text-align:left">毛利额</div>
            <div style="width: 30vw; text-align:left">毛利额3</div>
          </div>

          <div
            v-for="(item, index) in table_data4"
            :key="index"
            style="
              display: flex;
              color: #9c9c9c;
              font-size: 3vw;
              border-top: 1px solid #e2e2e2;
            "
          >
            <div
              v-if="index < table_data4.length - 1"
              style="
                min-width: 6vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            >
              {{ index + 1 }}
            </div>
            <div
              v-if="index == table_data4.length - 1"
              style="
                min-width: 6vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            ></div>
            <div
              style="
                width: 30vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            >
              {{ item.门店名称 }}
            </div>
            <el-tooltip :content="item.管易店铺名称" placement="top">
              <div
           
              style="
             
             width:35vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
                overflow: hidden; white-space: nowrap;
              "
            >
              {{ item.管易店铺名称}}
            </div>
</el-tooltip>
            <!-- <div
              style="
                width: 50vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            >
              {{ item.管易店铺名称 }}
            </div> -->
            <div
              style="
                width: 30vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            >
              {{ item.销售额  }}
            </div>
            <div
              style="
                width: 30vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            >
              {{ item.成本额 }}
            </div>
            <div
              style="
                width: 30vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            >
              {{ item.毛利额 }}
            </div>
            <div
              style="
                width: 30vw;
                text-align: center;
                border-left: 1px solid #e2e2e2;
                min-height: 3vh;
                line-height: 3vh;
              "
            >
              {{ item.成本价 }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--底部tab栏-->
    <Tabbar
      :choose_index="tab_type"
      :type="pagetype"
      :user_type2="user_type2"
    ></Tabbar>
  </div>
</template>

<script>
import LineChart from "@/components/LineChart";
import Tabbar from "@/components/Tabbar";
export default {
  components: {
    LineChart,
    Tabbar,
  },
  data() {
    return {
      show_tab: true,
      time_item: [
        {
          name: "今日",
          icon: require("@/assets/icon/shishi.png"),
          icon_xuan: require("@/assets/icon/shishi_xuan.png"),
          value: 0,
        },
        {
          name: "昨日",
          icon: require("@/assets/icon/zuori.png"),
          icon_xuan: require("@/assets/icon/zuori_xuan.png"),
          value: 1,
        },
        {
          name: "一周",
          icon: require("@/assets/icon/yizhou.png"),
          icon_xuan: require("@/assets/icon/yizhou_xuan.png"),
          value: 2,
        },
        {
          name: "当月",
          icon: require("@/assets/icon/dangyue.png"),
          icon_xuan: require("@/assets/icon/dangyue_xuan.png"),
          value: 3,
        },
      ], //时间队列
      pagetype: 0, //1 为总部看板 2为门店看板
      tab_type: 0, //tab栏
      startTime: "", //开始时间
      endTime: "", //结束时间
      table_data1: [], //数据体1
      table_data2: [], //数据体2
      table_data3: [], //数据体3
      table_data4: [], 
      table_data666: [], //数据体4 电商排名
      //数据体4 电商排名
      line_data: [], //折现统计图
      time_value: 0, //默认显示实时
      img_list: [
        require("@/assets/icon/hanshui.png"),
        require("@/assets/icon/keliu.png"),
        require("@/assets/icon/huiyuan.png"),
        require("@/assets/icon/yingye.png"),
        require("@/assets/icon/hanshuixiao.png"),
        require("@/assets/icon/hanshuimao.png"),
        require("@/assets/icon/keliuliang.png"),
        require("@/assets/icon/kedanjia.png"),
        require("@/assets/icon/zongmaoli.png"),
        require("@/assets/icon/chengben.png"),
        require("@/assets/icon/chengben.png"),
        require("@/assets/icon/chengben.png"),
      ],
      menu_list1: [], //菜单1
      // menu_list2:[],//菜单2
      loading: "", //loading
      new_show_date: "", //日期
      user_type2: false, //区域账号
      type2shopId: "", //区域id
      eight: "",
    };
  },
  watch: {
    // $route(){
    //     this.pagetype = this.$route.query.pagetype*1;//切换总部看板 与 门店看板
    //     this.curve_api();
    //     this.viewmenu_api();
    // }
  },
  mounted() {
    this.eight = JSON.parse(localStorage.getItem("user_info")).type;
    // console.log(this.eight, "aaa");
    if (localStorage.getItem("user_info") != "") {
      this.tab_type = this.$route.query.pagetype * 1;
      // console.log(this.tab_type, "o900909090-0-9");
      // this.pagetype = this.$route.query.pagetype*1;//切换总部看板 与 门店看板
      if (
        JSON.parse(localStorage.getItem("user_info")).type == 0 ||
        JSON.parse(localStorage.getItem("user_info")).type == 8
      ) {
        //总部看板
        this.pagetype = 1;
      } else {
        //门店看板
        this.pagetype = 2;
      }
      //区域看板
      if (
        JSON.parse(localStorage.getItem("user_info")).type == 2 ||
        JSON.parse(localStorage.getItem("user_info")).type == 4 ||
        JSON.parse(localStorage.getItem("user_info")).type == 6
      ) {
        //2为区域账号
        this.user_type2 = true;
        this.getShopByArea();
      } else {
        this.init();
      }
    }
  },
  methods: {
    //初始化
    init() {
      this.getShowDate(); //格式化日期
      this.showLoading();
      this.endTime = this.getYYYYMMDD();
      this.startTime = this.getYYYYMMDD();
      this.time_value = 0;
      this.curve_api();
      this.viewmenu_api();
      if (this.pagetype == 1) {
        //总部看板获取电商
        this.curve2_api();
      }
    },
    //获取区域详情
    getShopByArea() {
      this.$axios
        .post(this.$api.getShopByArea, {
          area: JSON.parse(localStorage.getItem("user_info")).shopId,
        })
        .then((res) => {
          this.type2shopId = res.data.data.shopId;
          this.init();
        });
    },
    //获取显示日期
    getShowDate() {
      this.new_show_date = this.getYYYYMMDD();
      // let new_date = new Date(Date.now());
      // let new_tomorrow = new Date(Date.now() - 86400000);
      // this.time_item[0].name = new_date.getDate() + '号';
      // this.time_item[1].name = new_tomorrow.getDate() + '号';
    },
    //loading
    showLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "查询中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    //时间格式化
    getYYYYMMDD(e) {
      let nowDate = "";
      if (e) {
        nowDate = new Date(e);
      } else {
        nowDate = new Date();
      }
      let day = nowDate.getDate();
      let month = nowDate.getMonth() + 1;
      let year = nowDate.getFullYear();
      return year + "-" + month + "-" + day;
    },
    //选择时间
    chooseTime(e) {
      this.showLoading();
      this.time_value = e;
      if (e == 0) {
        //实时
        this.startTime = this.getYYYYMMDD();
        this.endTime = this.getYYYYMMDD();
      } else if (e == 1) {
        //昨日
        this.startTime = this.getYYYYMMDD(Date.now() - 86400000);
        this.endTime = this.getYYYYMMDD(Date.now() - 86400000);
      } else if (e == 2) {
        //一周
        this.startTime = this.getYYYYMMDD(Date.now() - 518400000);
        this.endTime = this.getYYYYMMDD();
      } else if (e == 3) {
        //当月
        let nowDate = new Date();
        let month = nowDate.getMonth() + 1;
        let year = nowDate.getFullYear();
        this.startTime = year + "-" + month + "-1";
        this.endTime = this.getYYYYMMDD();
      }
      this.curve_api();
      this.curve2_api();
      this.viewmenu_api();
    },
    //获取电商排名
    curve2_api() {
      this.$axios
        .post(this.$api.curve2_api, {
          shopId: this.user_type2
            ? this.type2shopId
            : JSON.parse(localStorage.getItem("user_info")).userId,
          startTime: this.startTime,
          endTime: this.endTime,
          userType: JSON.parse(localStorage.getItem("user_info")).type,
        })
        .then((res) => {
          // console.log( res.data.data[1], "1111111111");
          if (res.data.data != "") {
            this.table_data4 = [];
            if(res.data.data[1]==undefined||res.data.data[1]==''){
              res.data.data[1]=[]
            }
            if(res.data.data[0]==undefined||res.data.data[0]==''){
              res.data.data[0]=[]
            }
            this.table_data4 = this.table_data4.concat(
              res.data.data[0],
              res.data.data[1]
            );
            // console.log(res, "电商");
            //对table_data4进行排序
            for (let i = 0; i < this.table_data4.length; i++) {
              for (let j = 0; j < this.table_data4.length; j++) {
                // console.log(this.table_data4.length[j])
                // console.log(this.table_data4.length[j + 1])
                if (
                  this.table_data4.length[j] < this.table_data4.length[j + 1]
                ) {
                  let tmp = this.table_data4.length[j];
                  this.table_data4.length[j] = this.table_data4.length[j + 1];
                  this.table_data4.length[j + 1] = tmp;
                }
              }
            }
            //计算总价
            let total = {
              门店名称: "合计",
              销售额: 0,
              成本额: 0,
              毛利额: 0,
              成本价:0
            };
            for (let i = 0; i < this.table_data4.length; i++) {
              total.销售额 = total.销售额 + this.table_data4[i].销售额 * 1;
              total.成本额 = total.成本额 + this.table_data4[i].成本额 * 1;
              total.毛利额 = total.毛利额 + this.table_data4[i].毛利额 * 1;
              total.成本价 = total.成本价 + this.table_data4[i].成本价 * 1;
            }
            total.销售额 = total.销售额.toFixed(2) * 1;
            total.成本额 = total.成本额.toFixed(2) * 1;
            total.毛利额 = total.毛利额.toFixed(2) * 1;
            total.成本价 = total.成本价.toFixed(2) * 1;
            this.table_data4.push(total);
          }
        });
    },
    //获取曲线及销售排名数据
    curve_api() {
      let url = this.$api.curve_api;
      let params = {
        userId: JSON.parse(localStorage.getItem("user_info")).userId,
        userType: JSON.parse(localStorage.getItem("user_info")).type,
        startTime: this.startTime,
        endTime: this.endTime,
      };
      if (
        JSON.parse(localStorage.getItem("user_info")).type != 0 &&
        JSON.parse(localStorage.getItem("user_info")).type != 8
      ) {
        //0为总部看板
        url = this.$api.curve_api + "1";
        if (this.user_type2) {
          //区域id
          params.shopId = this.type2shopId;
        } else {
          params.shopId = JSON.parse(localStorage.getItem("user_info")).shopId;
        }
      }

      this.$axios.post(url, params).then((res) => {
        // console.log(res, "a");
        this.loading.close();
        console.log(this.table_data3,"销售额")
        this.table_data3 = res.data.data[0];
        //计算合计数据
        if (this.pagetype == 1) {
          //1总店看板
          let total = {
            销售额: 0,
            毛利额:0,
            毛利率:0,
            gk毛利:0,
            gk毛利率:0,
            分支机构: "合计",
            分支机构编码: "合计",

          };
          // console.log(this.table_data3, "3");
          for (let i = 0; i < this.table_data3.length; i++) {
            this.table_data3[i].分支机构编码 = this.table_data3[i].分支机构;
            //去掉前五位
            // console.log(this.table_data3[i].分支机构,"分支机构")
            this.table_data3[i].分支机构 = this.table_data3[i].分支机构.substring(6, this.table_data3[i].分支机构.length);
            // console.log(this.table_data3[i].分支机构,"截取")
            total.销售额 = total.销售额 * 1 + this.table_data3[i].销售额 * 1;
            total.毛利额 = (total.毛利额 * 1 + this.table_data3[i].毛利额 * 1).toFixed(1);
            total.毛利率 = (total.毛利率 * 1 + this.table_data3[i].毛利率 * 1).toFixed(1);
            total.gk毛利 = (total.gk毛利 * 1 + this.table_data3[i].gk毛利 * 1).toFixed(1);
            total.gk毛利率 = (total.gk毛利率 * 1 + this.table_data3[i].gk毛利率 * 1).toFixed(1);
          }
          // console.log(this.table_data3, "33333");
          total.销售额 = total.销售额.toFixed(1);
          this.line_data = this.table_data3; //折线图
          console.log(total,"平均")
          console.log(total.毛利率, "毛利率");
          console.log(total.gk毛利, "gk毛利");
          console.log(total.销售额, "销售额");
          console.log(total.毛利率/total.销售额, "折线");
          
          total.毛利率=(total.毛利额/total.销售额*100).toFixed(2)+"%"
          // total.毛利率=(total.毛利率*100)+"%"
          total.gk毛利率=(total.gk毛利/total.销售额*100).toFixed(2)+"%"
          // total.gk毛利率=(total.gk毛利率*100)+"%"
          this.table_data3.push(total); //带上总计
          console.log(this.table_data3,"合计")
        } else {
          //2门店看板
          let total = {
            销售额: 0,
            营业员: "合计",
            会员销售额: 0,
            客单价: 0,
            客流量: 0,
          };
      
          for (let i = 0; i < this.table_data3.length; i++) {
            this.table_data3[i].营业员 = this.table_data3[i].营业员;
            total.销售额 = total.销售额 * 1 + this.table_data3[i].销售额 * 1;
            total.会员销售额 =
              total.会员销售额 * 1 + this.table_data3[i].会员销售额 * 1;
            total.客单价 = total.客单价 * 1 + this.table_data3[i].客单价 * 1;
            total.客流量 = total.客流量 * 1 + this.table_data3[i].客流量 * 1;
          }
          console.log(this.table_data3,"门店排名数据")
          total.销售额 = total.销售额.toFixed(2) * 1;
          total.会员销售额 = total.会员销售额.toFixed(2) * 1;
          total.客单价 = total.客单价.toFixed(2) * 1;
          total.客流量 = total.客流量.toFixed(2) * 1;
          this.line_data = this.table_data3; //折线图
          // console.log(this.line_data, "折线111");
          this.table_data3.push(total); //带上总计
          
        }
      });
      // console.log(this.table_data3,"门店排名数据")
    },
    //获取看板名字
    viewmenu_api() {
      this.$axios
        .post(this.$api.viewmenu_api, {
          userType: JSON.parse(localStorage.getItem("user_info")).type,
        })
        .then((res) => {
          //格式化菜单
          let menu_data = res.data.data;
          this.menu_list1 = [];
          // this.menu_list2 = [];
          let every_item = {};
          // for(let i=0;i<4;i++){
          //   every_item = {
          //     name:menu_data[i].view,
          //     sql: menu_data[i].sql
          //   }
          //   this.menu_list1.push(every_item)
          // }
          // for(let i=0;i<5;i++){
          //   every_item = {
          //     name:menu_data[i].view,
          //     sql: menu_data[i].sql
          //   }
          //   this.menu_list2.push(every_item)
          // }
          for (let i = 0; i < menu_data.length; i++) {
            every_item = {
              name: menu_data[i].view,
              sql: menu_data[i].sql,
            };
            this.menu_list1.push(every_item);
          }
          this.view1_api();
        });
    },
    //获取看板数据
    view1_api() {
      this.table_data1 = [];
      this.table_data2 = [];
// console.log(this.menu_list1,"11")
      for (let i = 0; i < this.menu_list1.length; i++) {
        if(this.menu_list1[i].name=="毛利率"){
          this.$delete(this.menu_list1, i)
        }
        console.log(this.menu_list1[i], "this.menu_list1");
        let query = {
          userId: JSON.parse(localStorage.getItem("user_info")).userId,
          userType: JSON.parse(localStorage.getItem("user_info")).type,
          shopId: this.user_type2
            ? this.type2shopId
            : JSON.parse(localStorage.getItem("user_info")).shopId,
          startTime: this.startTime,
          endTime: this.endTime,
          sql: this.menu_list1[i].sql,
        };
        this.$axios.post(this.$api.view1_api + (i + 1), query).then((res) => {
          // console.log(res.data.data, "every_data");
          let every_data = res.data.data;
          if (!every_data.length) {
            // console.log("g");
            return false;
          }
          if (this.pagetype == 1) {
            //总部两个数据源合并
            if (every_data[0] && every_data[1]) {
              //若两个都存在的情况
              // console.log("A");
              let every_name = this.menu_list1[i].name;
              every_data[0][every_name] =
                every_data[0][every_name] + every_data[1][every_name];
            } else if (every_data[1]) {
              // console.log("B");
              every_data[0][every_name] = every_data[1][every_name];
            }
          }

          for (let k = 0; k < this.menu_list1.length; k++) {
            //  console.log(every_data[0],"every_data[0]")
             if(every_data[0]!=null){
              if (this.menu_list1[k].name == Object.keys(every_data[0])[0]) {
              let every_item = {
                name: Object.keys(every_data[0])[0],
                value: Object.values(every_data[0])[0],
                item_index: k,
                img: this.img_list[k],
              };

              if (k < 4) {
               
                this.table_data1[k] = every_item;
              } else {
                this.table_data2[k - 4] = every_item;
                // console.log(every_item)
              }
              this.table_data1.push(",");
              this.table_data1.pop();
              // console.log(this.table_data1,"this.table_data1")
            }
   
             }
             else{
              // console.log(this.menu_list1[k].name == this.menu_list1[i].name,"this.menu_list1[k].name == this.menu_list1[i].name")
              if (this.menu_list1[k].name == this.menu_list1[i].name) {
              let every_item = {
                name: this.menu_list1[k].name,
                value:0,
                item_index: k,
                img: this.img_list[k],
              };

              if (k < 4) {
                this.table_data1[k] = every_item;
              } else {
                this.table_data2[k - 4] = every_item;
              }
              this.table_data1.push(",");
              this.table_data1.pop();
             
            }
             }
          
          }
        });
      }
      this.table_data666=[]
      this.mb=''
      this.mz=''

      this.mzQ=''
      this.mbQ=''
      console.log(this.table_data2,'门诊统筹叫你呢')
      this.$axios
        .post(this.$api.mbView, {
          startTime: this.startTime,
          endTime: this.endTime,
          userType: JSON.parse(localStorage.getItem("user_info")).type,
        })
        .then((res) => {
           console.log(res.data.data[0].opspPay,"慢病")
           this.mb=res.data.data[0].opspPay
          //  this.table_data2.push(res.data.data)
          this.table_data666.push({
            name:'慢病(博爱)',
            value:this.mb,
            img:"data:image/png;base64,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"

          })
        });
        this.$axios
        .post(this.$api.mzView, {
          startTime: this.startTime,
          endTime: this.endTime,
          userType: JSON.parse(localStorage.getItem("user_info")).type,
        })
        .then((res) => {
          console.log(res.data.data,"门诊")
          this.mz=res.data.data[0].opspPay
          this.table_data666.push({
            name:'门诊统筹（博爱）',
            value:this.mz,
            img:"data:image/png;base64,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"

          })
        });
        this.$axios
        .post(this.$api.mbViewQ, {
          startTime: this.startTime,
          endTime: this.endTime,
          userType: JSON.parse(localStorage.getItem("user_info")).type,
        })
        .then((res) => {
           console.log(res.data.data[0].opspPay,"慢病")
           this.mbQ=res.data.data[0].opspPay
          //  this.table_data2.push(res.data.data)
          this.table_data666.push({
            name:'慢病(一家亲)',
            value:this.mbQ,
            img:"data:image/png;base64,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"

          })
        });
        this.$axios
        .post(this.$api.mzViewQ, {
          startTime: this.startTime,
          endTime: this.endTime,
          userType: JSON.parse(localStorage.getItem("user_info")).type,
        })
        .then((res) => {
          console.log(res.data.data,"门诊")
          this.mzQ=res.data.data[0].opspPay
          this.table_data666.push({
            name:'门诊统筹(一家亲)',
            value:this.mzQ,
            img:"data:image/png;base64,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"

          })
        });


       

    },
  },
};
</script>
<style scoped>
.title_div {
  height: 9vh;
  background-image: linear-gradient(#04a9f3, #4ec5fb);
  color: #ffffff;
  /* line-height:12vh;
  text-align: center;
  font-size:4.6vw; */
}
.every_option1 {
  height: 8vh;
  width: 23vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.every_time {
  height: 5vh;
  width: 23vw;
  display: flex;
  align-items: center;
  justify-content: center;
}
.option_img {
  height: 5vw;
  width: 5vw;
  margin-right: 1.5vw;
}
.option_title {
  font-size: 4vw;
  font-weight: 800;
  color: #000000;
}
.every_option2 {
  width: 30vw;
  background-color: #ffffff;
  margin-top: 0.8vh;
}
.option2_font {
  height: 4vh;
  line-height: 5vh;
  /* font-size:1vw; */
  transform: scale(0.8);
  width: 34vw;
  margin-left: -2vw;
  color: #898989;
}
.option2_font2 {
  font-size: 3vw;
  color: #898989;
  margin-left: 1vw;
}
.ranking_icon {
  height: 3.6vw;
  width: 4vw;
}
.time_choose {
  height: 5.4vw;
  line-height: 5.4vw;
  font-size: 3.6vw;
  margin-left: 1.6vw;
}
.line_body {
  height: 23vh;
  background-color: #ffffff;
  overflow: scroll;
}
</style>
